import { apiRoutes } from "utils/constants";
import { api } from "./api";

export const chatService = {
  async getUser(id) {
    const response = await api.get(`${apiRoutes.users}/${id}`);
    return response.data;
  },

  async getChatMessages(id, options = {}) {
    const normalizedOptions =
      typeof options === "string" || options === null
        ? { cursor: options }
        : options;
    const { cursor = null, limit, direction, messageId } = normalizedOptions ?? {};
    const params = {};
    if (cursor) params.cursor = cursor;
    if (limit) params.limit = limit;
    if (direction) params.direction = direction;
    if (messageId) params.messageId = messageId;
    const response = await api.get(
        `${apiRoutes.chat}/${id}${apiRoutes.messages}`,
        { params }
    );
    return response.data;
  },

  async sendMessage(id, body) {
    const response = await api.post(
      `${apiRoutes.sendMesage}/${id}${apiRoutes.message}`,
      body
    );
    return response.data;
  },

  async updateChatRead(chatId) {
    const response = await api.patch(`${apiRoutes.chat}/${chatId}/read`);
    return response.data;
  },

  async updatePetDescription(petId, doctorDescription) {
    const response = await api.patch(
      `${apiRoutes.pet}/${petId}/doctor-description`,
      { ...doctorDescription }
    );
    return response.data;
  },

  async editMessage(chatId, messageId, message) {
    const response = await api.post(
        `${apiRoutes.sendMesage}/${chatId}/message/${messageId}/edit`,
        { message }
    );
    return response.data;
  },

  async deleteMessage(chatId, messageId) {
    const response = await api.delete(
        `${apiRoutes.sendMesage}/${chatId}/message/${messageId}/delete`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          data: {}
        }
    );
    return response.data;
  },
};
